import { Document, Page } from '@react-pdf/renderer';
import { observer } from 'mobx-react-lite';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { useEffect, useState } from 'react';
import JsBarcode from 'jsbarcode';

type Props = {
  tagDetails: {
    Title: string;
    'Element Type': string;
    'Vault Location': string;
    'Physical Case Count': number;
    Description: string;
    Barcode: string;
  };
};

const TagVerifyPDF = ({ tagDetails }: Props) => {
  const canvas = document.createElement('canvas');
  let barcode = tagDetails.Barcode || '1';
  JsBarcode(canvas, `${barcode}`, {
    format: 'CODE128', // Replace with the appropriate barcode format
    width: 1, // Adjust the width of the barcode bars
    height: 70, // Adjust the height of the barcode
    fontSize: 20, // Set the font size to your desired value
  });
  const base64Canvas = canvas.toDataURL('image/jpeg').split(';base64,')[1];
  const [tagHeaders, setTagHeaders] = useState<string[]>([]);

  useEffect(() => {
    if (tagDetails) {
      const columnHeaders = Object.keys(tagDetails);
      setTagHeaders(columnHeaders);
    }
  }, [tagDetails]);

  const element = (
    <html>
      <body>
        <style>
          {`
          * {
            font-size: 14px;
          }
          #container {
            margin: 30px;
          }
          #container img {
            height: 90px;
            margin-bottom: 20px;
          }
        .padding-4 {
          padding: 4px;
        }
        .tag-table,
        .tag-table th,
        .tag-table td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        `}
        </style>
        <div id="container">
          <img src="/assets/logo.png" alt="logo" />
          <table className="tag-table">
            <thead></thead>
            <tbody>
              {tagHeaders?.map((header: string) => {
                return (
                  <tr>
                    <th className="padding-4">{header}</th>
                    {header === 'Barcode' ? (
                      <td
                        style={{ textAlign: 'center', verticalAlign: 'middle' }}
                        className="padding-4"
                      >
                        <img
                          src={`data:image/jpeg;base64,${base64Canvas}`}
                          className="image-height"
                          alt="Barcode_image"
                          style={{ fontStyle: 'normal', fontSize: '16px' }}
                        />
                      </td>
                    ) : (
                      <td className="padding-4">
                        {tagDetails[header as keyof typeof tagDetails]}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </body>
    </html>
  );

  const html = ReactDOMServer.renderToStaticMarkup(element);
  return (
    <Document>
      <Page>
        <Html>{html}</Html>
      </Page>
    </Document>
  );
};

export default observer(TagVerifyPDF);
